import { useState } from 'react';
import { Button } from 'semantic-ui-react';
import moment from 'moment';
import { BackButton } from '../styles/TrainingViewStyles';
import { ContentArea } from '../styles/TableroGestionStyles';
import ContentRenderer from '../ContentRenderer';
import { getTypeLabel, isEntryReadByUser } from '../utils/tableroGestionUtils';
import UsersViewedModal from './UsersViewedModal';

const EntryContentView = ({
  entry,
  currentUserId,
  isAdmin,
  markingAsRead,
  onBack,
  onEdit,
  onMarkAsRead,
  interactions,
  loadingInteractions,
  fetchInteractions,
  onEntryUpdated,
}) => {
  const isRead = isEntryReadByUser(entry, currentUserId);
  const [usersModalOpen, setUsersModalOpen] = useState(false);

  return (
    <>
      <BackButton onClick={onBack}>
        <i className="fa-solid fa-arrow-left"></i>
        <span>Volver a las asignaciones</span>
      </BackButton>

      <ContentArea>
        <div className="content-header">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <div style={{ flex: 1 }}>
              <h1>{entry.title}</h1>
              <div className="content-meta">
                <div className="meta-item">
                  <span>📅</span>
                  <span>
                    {entry.entry_date
                      ? moment(entry.entry_date).format('DD/MM/YYYY')
                      : entry.createdAt
                      ? moment(entry.createdAt).format('DD/MM/YYYY')
                      : 'N/A'}
                  </span>
                </div>
                <div className="meta-item">
                  <span>📋</span>
                  <span>{getTypeLabel(entry.type)}</span>
                </div>
              </div>
            </div>
            {isAdmin && (
              <div style={{ display: 'flex', gap: '0.5rem', marginLeft: '1rem' }}>
                <Button
                  icon="users"
                  content="Ver usuarios"
                  onClick={() => setUsersModalOpen(true)}
                  color="blue"
                />
                <Button icon="edit" content="Editar" onClick={() => onEdit(entry)} />
              </div>
            )}
          </div>
        </div>
        <ContentRenderer
          interactions={interactions}
          loadingInteractions={loadingInteractions}
          entry={entry}
          currentUserId={currentUserId}
          onMarkAsRead={onMarkAsRead}
          fetchInteractions={fetchInteractions}
        />
        {entry.type !== 'quiz' && (
          <>
            {!isAdmin && entry && !isRead && (
              <div
                style={{
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '2px solid #e0e0e0',
                }}
              >
                <Button
                  primary
                  icon="check circle"
                  content="Marcar como Completado"
                  onClick={() => onMarkAsRead(entry)}
                  loading={markingAsRead}
                  disabled={markingAsRead}
                  size="large"
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                  }}
                />
              </div>
            )}
            {!isAdmin && entry && isRead && (
              <div
                style={{
                  marginTop: '2rem',
                  paddingTop: '2rem',
                  borderTop: '2px solid #e0e0e0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#10d8b4',
                  fontWeight: 600,
                }}
              >
                <span>✓</span>
                <span>Esta entrada ha sido marcada como completada</span>
              </div>
            )}
          </>
        )}
      </ContentArea>

      <UsersViewedModal
        open={usersModalOpen}
        onClose={() => setUsersModalOpen(false)}
        entry={entry}
        interactions={interactions}
        onEntryUpdated={onEntryUpdated}
      />
    </>
  );
};

export default EntryContentView;
